/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import { Component } from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';

import * as l10n from './log-cinematic-section-authentication.l10n';
import { TrafficLogCinematicStore } from '../../traffic-logs/traffic-log-cinematic/traffic-log-cinematic.store';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 *     Component for displaying Authentication section in a traffic log cinematic view.
 * @author Zhiqian Liu
 */
@Component({
    selector: 'log-cinematic-section-authentication',
    templateUrl: './log-cinematic-section-authentication.component.html',
})
export class LogCinematicSectionAuthenticationComponent {
    public readonly samlLog$ = this.logCinematicStore.samlLog$;

    public readonly oAuthLog$ = this.logCinematicStore.oAuthLog$;

    public readonly jwtLog$ = this.logCinematicStore.jwtLog$;

    public readonly ntlmLog$ = this.logCinematicStore.ntlmLog$;

    public readonly l10nKeys = l10nKeys;

    constructor(
        private readonly logCinematicStore: TrafficLogCinematicStore,
        private readonly l10nService: L10nService,
    ) {
        this.l10nService.registerSourceBundles(dictionary);
    }
}
